import { render, staticRenderFns } from "./suggestion-list.vue?vue&type=template&id=a39d4f84&scoped=true&"
import script from "./suggestion-list.vue?vue&type=script&lang=js&"
export * from "./suggestion-list.vue?vue&type=script&lang=js&"
import style0 from "./suggestion-list.vue?vue&type=style&index=0&id=a39d4f84&lang=scss&scoped=true&"
import style1 from "./suggestion-list.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39d4f84",
  null
  
)

/* custom blocks */
import block0 from "./suggestion-list.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports